import { SignUpWizard } from '@/components/signup/SignUpWizard';

export function SignUpPage() {
  return <SignUpWizard />;
}
